import React from "react";
const weekDays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
const SelectDays = ({ days, setDays }) => {
  return (
    <div className="accountability-days">
      {weekDays?.map((day) => (
        <div
          className={
            days[day] ? "p4 accountability-day active" : "p4 accountability-day"
          }
          onClick={() => {
            setDays ? setDays(day) : null;
          }}
          key={day}
        >
          {day.charAt(0).toUpperCase()}
        </div>
      ))}
    </div>
  );
};

export default SelectDays;
